import BaseService from '@/services/BaseService'

class EmployeeService {

    constructor() {
        this._httpService = new BaseService();
    }

    getEmployees() {
        let settings = {
            baseURL: `${this._httpService.baseUrl}/employee-management/employees`,
            method: 'GET'
        }
        console.info('employees')
        return this._httpService.service(settings)
    }

    getWorkplaceEmployees() {
        let settings = {
            baseURL: `${this._httpService.baseUrl}/employee-management/employees/workplace`,
            method: 'GET'
        }
        console.info('employees')
        return this._httpService.service(settings)
    }

}

export default EmployeeService